const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
  },

  tableRow: {
    height: 58,
  },

  header: {
    flex: 'none',
  },

  filter: {
    minWidth: 300,
  },
});

export default styles;
